import { PageHeader } from "@/components/page-header";
import { CsvImporter } from "@/components/csv-importer";

type Row = {
  name?: string; accountName?: string; contactEmail?: string;
  pipelineType?: string; stage?: string;
  valueUsd?: string; probability?: string; closeDate?: string;
  type?: string; nextStep?: string; leadSource?: string; description?: string;
  entity?: string;
};

const FIELD_MAP: Record<string, keyof Row> = {
  "deal name":    "name", "name": "name", "opportunity name": "name",
  "account name": "accountName", "account": "accountName",
  "contact email": "contactEmail", "email": "contactEmail",
  "pipeline":     "pipelineType",
  "stage":        "stage",
  "amount":       "valueUsd", "value": "valueUsd", "deal amount": "valueUsd",
  "probability":  "probability", "probability (%)": "probability",
  "closing date": "closeDate", "close date": "closeDate",
  "type":         "type",
  "next step":    "nextStep",
  "lead source":  "leadSource",
  "description":  "description",
  "entity":       "entity",
};

export default function DealImportPage() {
  return (
    <>
      <PageHeader
        title="Import Deals"
        description="Upload a Zoho-style Deals CSV. Accounts + contacts are linked by name/email."
      />
      <CsvImporter<Row>
        module="Deals"
        endpoint="/deals/bulk-import"
        backTo="/deals"
        listQueryKey={["/deals"]}
        fieldMap={FIELD_MAP}
        requiredField="name"
        description="Maps Zoho Deal columns → CRM fields. Link accounts by matching Account Name. Valid stages: QUALIFYING, DISCOVERY, PROPOSAL, NEGOTIATION, CLOSED_WON, CLOSED_LOST. Default pipeline: CONSULTING."
        previewColumns={[
          { field: "name",        label: "Deal" },
          { field: "accountName", label: "Account" },
          { field: "stage",       label: "Stage" },
          { field: "valueUsd",    label: "Amount" },
          { field: "closeDate",   label: "Close date" },
        ]}
      />
    </>
  );
}
